<template>
  <v-container fluid id="container" fill-height>
    <v-row align="center" justify="center" >
      <v-col id=hello-window>
        <img id="hello-text-img" justify="center" :src="img_src">
        <button id="exit-button" @click="$emit('click-exit-button')">
          <img id="exit-button-img" src="@/assets/hello_exit.png" alt="EXIT" />
        </button>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'HelloPage',
  data: ()=>{
    return {
      lang: "jp"
    }
  },
  computed: {
    img_src() {
      if (this.$store.state.lang == 'jp') {
        return require('@/assets/hello_jp.png');
      } else {
        return require('@/assets/hello_en.png');
      }
    }
  },
  methods: {
    toggleLang() {
      if (this.lang == 'jp') {
        this.lang = 'en';
      } else {
        this.lang = 'jp';
      }
    }
  }
}
</script>

<style scoped>
#container {
  min-height: 100%;
  background-image: url("~@/assets/background_1.gif");
  background-size:100% 100%;
}

#hello-window {
   max-width: 650px;
   position:relative;
}

#hello-text-img {
  width: 100%;
}

#exit-button {
  outline : none;
  height: auto;  
  position: absolute;
  width: 22%;
  right: 10%;
  bottom: 30px;
  right: 30px;
}

#exit-button img {
  width: 100%;
}


</style>
